module.exports = __webpack_public_path__ + "img/img_ibama_celular.838a0d5a.jpg";